import { useState, useCallback } from "react";

export type Rotation = 0 | 90 | 180 | 270;

export const useOrientation = () => {
  const [orientation, setOrientation] = useState<Rotation>(0);

  // orientação inicial (usa storage -> ScreenOrientation -> prop)
  const stored = (Number(localStorage.getItem("@datasales:orientation")) ||
    0) as Rotation;

  const handleChangeOrientation = useCallback((__orientation: Rotation) => {
    setOrientation(__orientation);
    localStorage.setItem("@datasales:orientation", String(__orientation));
  }, []);

  return {
    isPortrait: Number(stored || 0) === 90 || Number(stored || 0) === 270,
    rotation: (stored || 0) as Rotation,
    orientation,
    handleChangeOrientation,
  };
};
